import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Company } from "src/models/company.model";

@Injectable({
    providedIn: "root",
})
export class CompanyService {
    constructor(private http: HttpClient) {}

    list(): Observable<any> {
        return this.http.get(`/api/qualif_pme_entreprise/`) as Observable<any>;
    }

    update(slug: string, data: object): Observable<Company> {
        return this.http.patch(`/api/qualif_pme_entreprise/${slug}/`, data) as Observable<Company>;
    }

    create(data: object): Observable<Company> {
        return this.http.post(`/api/qualif_pme_entreprise/`, data) as Observable<Company>;
    }

    delete(slug: string): Observable<Company> {
        return this.http.delete(`/api/qualif_pme_entreprise/${slug}/`) as Observable<Company>;
    }

    supplierCompanies(): Observable<any> {
        return this.http.get(`/api/qualif_pme_entreprise/supplier_companies/`) as Observable<any>;
    }

    get(slug: string): Observable<any> {
        return this.http.get(`/api/qualif_pme_entreprise/${slug}/`) as Observable<Company>;
    }

    login(payload): Observable<Company> {
        return this.http.post(`/api/qualif_pme_entreprise/login/`, payload) as Observable<Company>;
    }

    isAuthenticated(): boolean {
        return localStorage.getItem("company") != null;
    }

    logout() {
        localStorage.removeItem("company");
    }

    checkAuthentication(payload): Observable<Company> {
        return this.http.post(`/api/qualif_pme_entreprise/check_authentication/`, payload) as Observable<Company>;
    }

    statistics(): Observable<any> {
        return this.http.get(`/api/qualif_pme_entreprise/statistics/`) as Observable<any>;
    }
}
